import api from '../services/Api';
import { fetchingConsentsAction, fetchedConsentsAction } from '../actions/RaffleFormActions';
import { fetchedConsentDetailAction, fetchingConsentDetailAction } from '../actions/ConsentModalActions';
import { networkErrorAction } from '../actions/UiActions';

/**
 * @typedef {Object} ConsentData
 * @property {string} consentVersionId
 * @property {string} consentId
 * @property {string} version
 * @property {string} title
 * @property {string} perex
 * @property {string} detailUrl
 * @property {string} text
 */

/**
 * @typedef {Object} ConsentResponse
 * @property {bool} success
 * @property {ConsentData[]} data.requiredConsentDetails
 */

class ConsentRepository {

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchConsents = () => (dispatch) => {
		dispatch(fetchingConsentsAction());
		return api.get('/consent').then(res => {
			const data = res.data;
			if (data.success && data.data && data.data.requiredConsentDetails) {
				dispatch(fetchedConsentsAction(data.data.requiredConsentDetails));
			}
			else {
				dispatch(fetchedConsentsAction(null));
			}
		}).catch((error) => {
			dispatch(networkErrorAction(error));
		});
	};

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchConsentDetail = (detailUrl) => (dispatch) => {
		dispatch(fetchingConsentDetailAction());
		return api.get('/consent/detail', {
			params: { detailUrl }
		}).then(res => {
			const data = res.data;
			const html = data && data.html ? data.html : null;
			dispatch(fetchedConsentDetailAction(detailUrl, html));
		}).catch((error) => {
			const response = error.response;
			if (response && response.status === 404) {
				dispatch(fetchedConsentDetailAction(detailUrl, null));
			}
			dispatch(networkErrorAction(error));
		});
	};
}

export default new ConsentRepository();


// WEBPACK FOOTER //
// ./repositories/ConsentRepository.js